import React, { useEffect } from 'react';
import TopQuestion from '../../utils/question/topQuestion';
import { connect } from 'react-redux';
import WordCollection from '../../utils/question/wordCollection';
import PassageFill from '../../utils/question/passageFill';
import { appendScript } from '../../../../utils/appendScript';
import SaSpeechRecorder from '../sa/saSpeechRecorder';
import { removeScript } from '../../../../utils/removeScript';
import CombineSelected from './combineSelected';
import $ from 'jquery';
const ClozePassage = ({
	leftSectionProps: { wordbank, questionId, prompt, clozeQuestion },
	isFeedback,
}) => {
	useEffect(() => {
		if (!isFeedback) {
			appendScript('cloze');
		}
		return () => {
			if (!$('.converse-pasage span').hasClass('to-be-filled')) {
				$('.record-container').css('display', 'none');
			}
			removeScript('cloze');
		};
	}, [wordbank, isFeedback]);
	return (
		<section className="que-container ">
			<section className="quiz-page-content">
				<TopQuestion />
				<p
					style={{ display: 'none' }}
					className="error test_validation"
					id="errorWordcloudPage"
				>
					Please answer the question
				</p>
				<section className="quiz-area-options">
					<PassageFill />
				</section>
				<section className="quiz-area-options">
					<h6>{prompt}</h6>
					<WordCollection wordbank={wordbank} questionId={questionId} />
					<div className="clearfix step-toptions-wrapper" id="div_90681">
						<div id="resetClozeButton" className="word-question-reset resetButton">
							Reset <i className="fa fa-repeat" aria-hidden="true"></i>
						</div>
					</div>
					<div className="record-container" style={{ display: 'none' }}>
						<h5>Record the sentence you have formed :</h5>
						<CombineSelected
							passage={clozeQuestion.split('[blank]')}
							questionId={questionId}
						/>
						<SaSpeechRecorder />
					</div>
					<input type="hidden" id="clozeResponse" name="clozeResponse" />
				</section>
			</section>
		</section>
	);
};

const mapStateToProps = (state) => {
	const { leftSectionProps, isFeedback } = state.rootReducer.testPageDetails;

	return {
		leftSectionProps,
		isFeedback,
	};
};

export default connect(mapStateToProps)(ClozePassage);
